import React from "react";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import css from "./css.css";

export const acceptedCalendarViews = ["month", "week", "day"]


function renderEventContent(eventInfo) {
    const title = ((eventInfo.timeText || "") + " " + eventInfo.event.title).trim();
    return (
      <span title={title} className={ css[`${eventInfo.view.type}-event-text`] }>
        {eventInfo.timeText && <b className={ css.eventTime }>{eventInfo.timeText}</b>}
        <i className={css.eventTitle}>{eventInfo.event.title}</i>
      </span>
    )
}


const headerToolbar = {
    left: 'prev,next today title',
    center: '',
    right: acceptedCalendarViews.join()
}

const calenderViews = {
    month: { type: 'dayGridMonth' },
    week: { type: 'timeGridWeek' },
    day: { type: 'timeGridDay' },
    
    timeGrid: {
        eventMaxStack: 3,
        slotEventOverlap: false,
        eventMinHeight: 25,
        slotLabelFormat: {
            hour: 'numeric',
            minute: 'numeric',
            hour12: false
        },
        eventTimeFormat: {
            hour: 'numeric',
            minute: 'numeric',
            hour12: false
        }
    },
    timeGridDay: {
        eventMaxStack: 5,
    },
    dayGridMonth: {
        displayEventTime: false,
        displayEventEnd: false
    },
    businessDays: {
        type: 'dayGridMonth',
        weekends: false
    },
}

const calendarPlugins = [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]

export const CalendarComponent = React.forwardRef((props, ref) => {
    return (
        <div className={css.calendarContainer}>
            <FullCalendar
                ref={ ref }
                eventContent={renderEventContent} // custom render function
                plugins={calendarPlugins}
                fixedWeekCount={false}

                eventClassNames={ css.eventWrap }
                moreLinkClassNames={ css.moreLink }
                headerToolbar={headerToolbar}

                views={calenderViews}
                {...props}

                editable={false}
                selectable={false}
                selectMirror={false}
            />
        </div>
    )
})